import * as go from 'gojs';
import { IS_SIDEBAR_TYPE_PROP } from '../../common/config/common-prop-names';
import { updateGroupBoundaries } from './group-bounds-utils';

export const groupOverrideRotatingTool = (diagram: go.Diagram, category: string) => {
  const tool = diagram.toolManager.rotatingTool as go.RotatingTool;
  overrideRotate(category, tool);
};

const overrideRotate = (groupCategory: string, tool: go.RotatingTool) => {
  const rotateBase = tool.rotate.bind(tool);

  tool.rotate = (newAngle: number) => {
    if (!tool?.adornedObject?.part) {
      return;
    }
    const node = tool.adornedObject.part;

    if (node?.category === groupCategory) {
      rotateGroupMembers(node as go.Group, tool, newAngle);
    }

    rotateBase.call(tool, newAngle);

    if (node.containingGroup?.category === groupCategory) {
      updateGroupBoundaries(node.containingGroup);
    }
  };
};

const rotateGroupMembers = (group: go.Group, tool: go.RotatingTool, newAngle: number) => {
  const delta = newAngle - group.rotateObject.angle;

  group.memberParts
    .filter((p) => p instanceof go.Node)
    .filter((p) => !!p.data[IS_SIDEBAR_TYPE_PROP])
    .each((part) => {
      const rotationPoint = part.getDocumentPoint(go.Spot.Center);
      const originalAngle = part.rotateObject.angle;
      const pt = part.location.copy();
      part.location = pt
        .subtract(rotationPoint)
        .rotate(newAngle - originalAngle)
        .add(rotationPoint);
      part.rotateObject.angle += delta;
    });
};
